import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { fetchLoanPlan } from "../loanPlanActions";

import Layout from "../../shared/components/layouts/MainLayout";

import LoanSummary from "../components/LoanSummary";
import LoanPlanOverviewTradeDocumentsTable from "./LoanPlanOverviewTradeDocumentsTable";
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import { PageViewName, TrackEventName } from '../../shared/constants/SegmentEvents';

class LoanPlanOverview extends Component {
  componentDidMount() {
    this.props.fetchLoanPlan(this.props.match.params.loan_plan_id)
    segmentEventTracker.trackPageView(PageViewName.LOAN_DETAILS_VIEWED);
  }

  loanPlanType = () => {
    const { type } = this.props.loan_plan;
    switch(type) {
      case "POFinancingLoanPlan":
        return "Purchase Order Financing";
      case "InvoiceDiscountingLoanPlan":
        return "Invoice Discounting";
      default:
        return 'UnknownLoanPlanType';
    }
  }

  onClickBackButton = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.props.push('/loan_plans');
  }

  notFound() {
    if(this.props.loan_plan.id) return;
    return (
      <h1 className="subhead">{`Loan plan #${this.props.match.params.loan_plan_id} was not found!`}</h1>
    )
  }

  render() {
    if(this.props.loading) return <Layout><div className="loading"/></Layout>;
    const { buyer_name, trade_documents = [] } = this.props.loan_plan;

    return (
      <Layout backButtonAction={this.onClickBackButton}>
        {this.notFound()}
        <div className="ds-cardList">
          <LoanSummary loan_plan={this.props.loan_plan} loanPlanType={this.loanPlanType()}/>
          <LoanPlanOverviewTradeDocumentsTable trade_documents={trade_documents} buyer_name={buyer_name}/>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    loan_plan: state.loan_plan,
    loading: state.shared.ui.loading.default,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push: (url) => dispatch(push(url)),
    fetchLoanPlan: (id, callback) => dispatch(fetchLoanPlan(id, callback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoanPlanOverview);



// WEBPACK FOOTER //
// ./src/features/loans/containers/LoanPlanOverview.js